import { render, staticRenderFns } from "./UserEditTabChangePassword.vue?vue&type=template&id=22320742"
import script from "./UserEditTabChangePassword.vue?vue&type=script&lang=js"
export * from "./UserEditTabChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports